$(document).ready(function(){
  $('.fixed-nav-container .fixed-nav-wrapper a').click(function(e){
    e.preventDefault();

    var target = $(this).data('target');
    var targetElement = $('#'+target);


    $('.section-change').removeClass('active');
    $('.fixed-nav-container .fixed-nav-wrapper a').removeClass('active');

    $(this).addClass('active');
    targetElement.addClass('active');

    var offsetToGo = targetElement.offset().top - $('#site-header').height() - 30;
    console.log(offsetToGo, targetElement);
    $('body, html').animate({scrollTop: offsetToGo}, 650);
  });
});
